import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../logic/api/graphQL/useCustomQuery';
import { CurrentUserGq, CurrentUserGqProps } from '../models/CurrentUserGq';
import { CurrentTeamGq, CurrentTeamGqProps } from '../models/CurrentTeamGq';
import { PublicUserGq, PublicUserGqProps } from '../models/PublicUserGq';
import { SubscriptionEventGq, SubscriptionEventGqProps } from '../models/SubscriptionEventGq';

export function useGetCurrentUserGq(
  command: CommandGq = {},
  options?: Partial<QueryHookOptions<GQLData, GQLVariables>>
) {
  const query = useCustomQuery<GQLData, GQLVariables>(gqTag, {
    variables: { command: command },
    ...options,
  });

  return {
    query,
    result:
      query.data?.users?.getCurrentUser?.user ?? query.previousData?.users?.getCurrentUser?.user,
    ...(query.data?.users?.getCurrentUser ?? query.previousData?.users?.getCurrentUser),
  };
}

const gqTag = gql`
  query GetCurrentUser($command: GetCurrentUserCommand!) {
    users {
      getCurrentUser(command: $command) {
        user { ${CurrentUserGqProps} }
        availableUsers { ${PublicUserGqProps} }
        team { ${CurrentTeamGqProps} }
        subscriptionEvents { ${SubscriptionEventGqProps} }
      }
    }
  }
`;

interface GQLData {
  readonly users: {
    readonly getCurrentUser: CurrentUserResultsGq;
  };
}

export interface CurrentUserResultsGq {
  readonly user: CurrentUserGq;
  readonly availableUsers: PublicUserGq[];
  readonly team: CurrentTeamGq;
  readonly subscriptionEvents: SubscriptionEventGq[];
}

export interface GQLVariables {
  command: CommandGq;
}

export interface CommandGq {}
